import { render } from "./tw-form-item.vue?vue&type=template&id=58462cac"
import script from "./tw-form-item.vue?vue&type=script&lang=js"
export * from "./tw-form-item.vue?vue&type=script&lang=js"
script.render = render

export default script